document.addEventListener("DOMContentLoaded", function () {

    const contacts = {
        default: {
            whatsapp: "+86 166 3166 9180",
            email: "info@verakofurniture.com"
        },
        jenny: {
            whatsapp: "+86 130 6883 0894",
            email: "jenny@verakofurniture.com"
        },
        cecilia: {
            whatsapp: "+86 181 0326 5999",
            email: "cecilia@verakofurniture.com"
        },
        mia: {
            whatsapp: "+86 137 3163 9329",
            email: "mia@verakofurniture.com"
        },
        andy: {
            whatsapp: "+86 187 3360 6303",
            email: "andy@verakofurniture.com"
        },
        ray: {
            whatsapp: "+86 195 3110 3649",
            email: "ray@verakofurniture.com"
        },
    };

    // ===== 保存 ref =====
    const params = new URLSearchParams(window.location.search);
    let ref = params.get("ref");

    if (ref && contacts[ref]) {
        localStorage.setItem("sales_ref", ref);
    } else {
        ref = localStorage.getItem("sales_ref");
    }

    const c = contacts[ref] || contacts.default;

    document.querySelectorAll(".text-block p").forEach(function (p) {

        const txt = p.textContent.trim();

        if (txt.startsWith("Whatsapp")) {
            p.innerHTML =
                `Whatsapp: <a href="https://wa.me/${c.whatsapp.replace(/\D/g,"")}">${c.whatsapp}</a>`;
        }

        if (txt.startsWith("Email")) {
            p.innerHTML =
                `Email: <a href="mailto:${c.email}">${c.email}</a>`;
        }

    });

});